module.exports = __webpack_public_path__ + "img/Facebook_logo.90b8f88d.png";